import IKitCarouselCard from '@models/IKitCarouselCard';
import { IMeta } from '@models/IMeta';
import KitCarouselCard from '@molecules/KitCarouselCard/KitCarouselCard';
import PaginationCarousel from '@molecules/PaginationCarousel/PaginationCarousel';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly items: IKitCarouselCard[];
  readonly meta: IMeta;
}

const KitCarousel = ({ items, meta }: Props) =>
  items?.length > 0 ? (
    <section
      data-epi-block-id={meta?.contentLink}
      className="component-padding bg-black-100 text-white"
      data-testid="CT-62-Kit-Carousel"
    >
      <SoftLoadWrapper>
        <div
          data-epi-property-name={meta?.editHints?.items}
          className="container"
        >
          <PaginationCarousel
            id="kit-carousel"
            paginationClasses="mt-11 xl:mt-20"
            dataTestId="CT-62-Kit-Carousel-Pagination-Carousel"
          >
            {items.map((item) => (
              <SwiperSlide
                key={`Kit-carousel-${item.productTitle}`}
                className="stretch-card"
              >
                <KitCarouselCard {...item} />
              </SwiperSlide>
            ))}
          </PaginationCarousel>
        </div>
      </SoftLoadWrapper>
    </section>
  ) : null;

export default KitCarousel;
